import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { parseLink } from "../../../../utils/linkParser/linkParser";
import { Workload } from "../../../../schema/types/workload/entity";
import { useCanRenderAdvanced } from "./useCanRenderAdvanced";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { store } from "../../../../store";
import { cloneDeep, get } from "lodash";
import { request } from "../../../../services/cpln";
import { WorkloadGVCTagFn } from "../../../../components/antd/kindselect/tagRenderers/workloadGvcTag";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";
import { DomainInput, DomainPortRouteInput } from "../../../../schema/types/domain/input";
import { CpLabelTooltip } from "../../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../../gvc/testNewForm/CpTooltip";
import { KindSelectState } from "../../../../components/antd/kindselect/KindSelect";
import { getDefaultDomainPortInput, getDefaultDomainPortRouteInput } from "../utils/utils";

interface Props {}
export const WorkloadSubdomain: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const canRender = useCanRenderAdvanced();
  const routingMode = useCpFormValue("advanced.spec.routingMode");

  const workload: KindSelectState = useCpFormValue("advanced.spec.workload");

  React.useEffect(() => {
    const form = store.getState().form.instances[id];
    const values: DomainInput = form.values;
    if (values.advanced.spec.routingMode !== "workloadSubdomain") {
      return;
    }

    const link = workload.link;
    const parsedLink = parseLink(link);
    const newGvcLink = `/org/${parsedLink.org}/gvc/${parsedLink.gvc}`;

    const gvcLink = get(values, `gvc.link`);
    if (gvcLink !== newGvcLink) {
      updateGvcItem(newGvcLink, parsedLink.gvc);
      updatePorts(workload);
    }
  }, [workload]);

  async function updateGvcItem(gvcLink: string, gvcName: string) {
    try {
      formSetValue(id, `gvc.value`, gvcName);
      formSetValue(id, `gvc.link`, gvcLink);
      const { data } = await request({ url: gvcLink });
      formSetValue(id, `gvc.item`, data);
    } catch (e) {}
  }

  async function updatePorts(workload: KindSelectState) {
    try {
      const form = store.getState().form.instances[id];
      const values: DomainInput = form.values;

      let ports = cloneDeep(values.advanced.spec.ports);
      const routes: DomainPortRouteInput[] = [
        {
          ...getDefaultDomainPortRouteInput(),
          prefix: "/",
          workload: workload,
        },
      ];
      ports = ports.map((p) => ({ ...p, routes: routes }));
      if (ports.length < 1) {
        const newPort = getDefaultDomainPortInput();
        newPort.routes = routes;
        ports.push(newPort);
        formSetValue(id, `meta.activePortKey`, newPort.id);
      }

      formSetValue(id, `advanced.spec.ports`, ports);
    } catch (e) {}
  }

  if (routingMode !== "workloadSubdomain" || !canRender) {
    return null;
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container" data-section-id={"workload"}>
      <Card>
        <CardTitle>
          Workload Subdomain Routing
          <CpErrorWarningArrayIcon names={[`advanced.spec.workload`]} />
        </CardTitle>
        <CardContent>
          <CpFormItem>
            <CpLabelTooltip>
              <CpLabel name="advanced.spec.workload">Workload Selection</CpLabel>
              <CpTooltip tooltipProps={{ title: "Select a workload of type Stateful" }} />
            </CpLabelTooltip>
            <CpKindSelect
              name="advanced.spec.workload"
              filterOptionsFn={(item) => (item as Workload).spec.type === "stateful"}
              kind="workload"
              optionValue={`relative`}
              style={{ maxWidth: 600 }}
              tagRenderers={[WorkloadGVCTagFn(false)]}
            />
            <CpErrorWarning name="advanced.spec.workload" />
          </CpFormItem>
        </CardContent>
      </Card>
    </div>
  );
};
